import React, { memo } from 'react';
import cn from 'classnames';
import AllUpHeader from './AllUpHeader';
import { allUpItemFragment, DeepReadonly } from '@src/utils/type-utils';
import { BetPickDetail } from '@mobx/stores/kol/kol-store';
import { AllupBetlineFragment, ContentBlockFragment } from '@graphqlTypes/sitecore';
import AllUpSwipeItem from './AllUpSwipeItem';
import BetPickButton from './bet-pick-button';
import AllUpManualSwipeItem from './AllUpManualSwipeItem';
import useWindowSize from '@src/utils/useWindowSize';
import { getRaceNum } from '@src/utils/kolBetpickUtils';

type Props = {
    betpickDetail: DeepReadonly<BetPickDetail>;
    type: 'leader' | 'race';
    jsBridge: any;
    allUpList: allUpItemFragment[];
    AllUpDataItem: AllupBetlineFragment | null;
    racesList: any[];
    raceDay: number;
    venueCode: string;
    displayManualInput: boolean;
    contentBlock?: ContentBlockFragment | null;
};

/** 用于betpick-ALL UP 组件 */
const AllUpItem = ({
    betpickDetail,
    type,
    jsBridge,
    racesList,
    contentBlock,
    allUpList,
    raceDay,
    venueCode,
    AllUpDataItem,
    displayManualInput,
}: Props) => {
    // console.log('AllUpDataItem===========', AllUpDataItem);
    // console.log('allUpList===========', allUpList);
    // const isStrike = allUpList.every((item) => item.buttonStatus?.value === 'Strike');
    const { width } = useWindowSize();
    const isPadDSize = width >= 630;
    const isStrike = AllUpDataItem?.allUpButtonStatus?.value === 'Strike';

    const raceNumbers = allUpList
        .map((item) => item.parent?.raceNo?.numberValue)
        .filter((num) => typeof num === 'number');

    const curAllUpItem = allUpList.length > 1 ? allUpList[0] : null;
    const allupPath = curAllUpItem ? getRaceNum(curAllUpItem.path) : null;
    const raceNo = allupPath?.betline ? `${allupPath?.betline}/${allupPath.race}/All-Up` : '';

    return (
        <div
            className={cn(
                'relative overflow-clip  flex flex-col items-stretch bg-white min-h-[158px] px-3 pb-3 rounded-[8px] mt-4',
                { 'border-[#FF9900]': isStrike },
                { 'border-[4px]': isStrike },
                { 'pt-[30px]': isStrike }
            )}
            style={{ boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.15)' }}
        >
            <div>
                <AllUpHeader
                    AllUpDataItem={AllUpDataItem ?? null}
                    type={type}
                    jsBridge={jsBridge}
                    contentBlock={contentBlock}
                    raceNumbers={raceNumbers}
                    raceNo={raceNo}
                ></AllUpHeader>
            </div>

            <div className='flex overflow-x-auto space-x-2 overflow-y-hidden mt-2 hide-scrollbar'>
                {allUpList.map((item, index) => {
                    const raceNo = item ? item.parent.raceNo?.numberValue ?? 0 : 0;
                    const raceObj =
                        racesList && racesList?.length > 0
                            ? racesList?.find((i) => i.no === raceNo)
                            : [];
                    // console.log('racesList---------', racesList);

                    const baseClass = (() => {
                        if (isPadDSize) {
                            return allUpList.length === 2
                                ? 'flex-1'
                                : allUpList.length === 3
                                ? 'w-[300px]'
                                : 'w-[300px]';
                        }

                        return item.betPickType?.targetItem?.name === 'QQP'
                            ? 'w-[273px] shrink-0'
                            : 'w-[230px] shrink-0';
                    })();

                    return (
                        <div key={index} className={cn(baseClass)}>
                            {displayManualInput ? (
                                <AllUpManualSwipeItem allUpItem={item} />
                            ) : (
                                <AllUpSwipeItem
                                    allUpItem={item}
                                    jsBridge={jsBridge}
                                    raceRunner={raceObj?.runners ?? []}
                                    raceDay={raceDay}
                                    venueCode={venueCode}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
            <div className='grow pt-1 md:pt-2 leading-[16px]'>
                <div
                    className={cn('flex flex-col  items-start align-middle', { 'mt-2': !isStrike })}
                >
                    <div className='w-full'>
                        <BetPickButton
                            raceNo={raceNo}
                            curAllUpItem={curAllUpItem}
                            betpickDetail={betpickDetail}
                            isAllUpItem
                            AllUpDataItem={AllUpDataItem}
                        ></BetPickButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(AllUpItem);
